const mainTiles = document.querySelectorAll('.section--stack__main[data-stack-toggle]');

mainTiles.forEach(tile => {
  tile.addEventListener('click', () => {
    const wasExpanded = tile.classList.contains('is-expanded');

    mainTiles.forEach(other => {
      if (other !== tile) other.classList.remove('is-expanded');
    });

    tile.classList.toggle('is-expanded', !wasExpanded);
  });
});
